/* Bayou Beignet product-story reveals. The narrative remains complete
   without JavaScript; this only adds an optional one-time entrance. */
(function () {
  var stories = document.querySelectorAll('[data-bb-story]');
  if (!stories.length) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduceMotion.matches || !('IntersectionObserver' in window)) return;

  Array.prototype.forEach.call(stories, function (story) {
    var targets = story.querySelectorAll('[data-bb-story-reveal]');
    if (!targets.length) return;

    story.classList.add('bb-story--motion-ready');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });

    Array.prototype.forEach.call(targets, function (target, index) {
      target.style.setProperty('--bb-story-delay', Math.min(index * 60, 180) + 'ms');
      observer.observe(target);
    });
  });
})();
